import { useDispatch, useSelector } from 'react-redux';

import EditItem from '../../../../shared/components/IconButtons/EditItem';
import CampoInputTexto from '../../../../shared/components/CampoInputComButton/CampoInputTexto/CampoInputTexto';
import { handleOcorrenciaChange } from '../../../../../store/reducers/ocorrenciaSlice';

const CampoInputDanoReclamado = ({ onClick, editButton, disabled }) => {

    const dispatch = useDispatch()
    const { damage } = useSelector(state => state.ocorrenciaState)
    
    const handleChange = (name, value) => {
        dispatch(handleOcorrenciaChange({[name]: value}))
    }
    const handleClick = (e) => {
        e.preventDefault()
        onClick("damage")
    }

    return (
        <CampoInputTexto
            id="inputDanoReclamado"
            titulo="Dano reclamado*"
            onChange={handleChange}
            required
            name="damage"
            value={damage}
            disabled={disabled}
        >
            {
                editButton ? <EditItem onClick={handleClick} /> : <></>
            }
        </CampoInputTexto>
    )
}

export default CampoInputDanoReclamado
